const columnsAllTypeWorkLeave = [
  {
    key: "orderNumber",
    title: "Order",
    dataIndex: "orderNumber",
    align: "center",
  },
  {
    key: "code",
    title: "Code",
    dataIndex: "code",
    scopedSlots: { customRender: "code" },
    sorter: (a, b) => {
      return a.code.localeCompare(b.code);
    },
  },

  {
    title: "Title",
    key: "title",
    dataIndex: "title",
    scopedSlots: { customRender: "titleType" },
    sorter: (a, b) => {
      return a.title.localeCompare(b.title);
    },
  },
  // {
  //   title: "Số ngày nghỉ tối đa",
  //   dataIndex: "limit",
  //   key: "limit",
  //   align: "center",
  // },
  {
    title: "Benefit",
    key: "benefit",
    dataIndex: "benefit",
    scopedSlots: { customRender: "benefit" },
  },
  // {
  //   title: "Tạo bởi",
  //   key: "author",
  //   scopedSlots: { customRender: "author" },
  // },
  {
    title: "Created At",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Updated At",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export { columnsAllTypeWorkLeave };
